import { mediaQuery } from 'constants/ui';

export const tilesRowStyles = {
  display: 'grid',
  gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
  gap: '12px',

  [mediaQuery.mobileAndTablet]: {
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  },

  [mediaQuery.mobile]: {
    gridTemplateColumns: '1fr',
  },
};

export const tileCardStyles = {
  padding: '4px 8px',
};
